import { loginByUsername, logout, getUserInfo,getWxLoginRequest } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { Message } from 'element-ui'
import router from '@/router'

const user = {
  state: {
    user: '',
    status: '',
    token: getToken() || 'demo-token',
    name: '袁嘉文',
    avatar: '',
    userId: '1',
    introduction: '',
    buttons: [],
    roles: ['admin'],
    permissions: new Set(['all']),
    third_account:[],
    bindWxModelShow:false,
    wxHasBind:true  // 演示模式设置为已绑定，避免微信绑定提示
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = null
      state.permissions = permissions
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_BUTTONS: (state, buttons) => {
      state.buttons = buttons
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_THIRD_ACCOUNT: (state, third_account) => {
      state.third_account = third_account
    },
    SET_WXMODEL:(state,model)=>{
      state.bindWxModelShow=model
    },
    SET_WX_HASBIND:(state,bind)=>{
      state.wxHasBind=bind
    },
  },

  actions: {
    // 用户名登录
    LoginByUsername ({ commit }, userInfo) {
      const username = userInfo.account.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(userInfo).then(response => {
          const data = response.data
          commit('SET_TOKEN', data.token)
          setToken(data.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 二维码登录
    LoginByCode ({ commit }, uuid) {
      return new Promise((resolve, reject) => {
        getWxLoginRequest({uuid}).then(response => {
          if(response.data){
          const data = response.data
          commit('SET_TOKEN', data)
          setToken(data)
          resolve()
        }else{
          reject()
        }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息 - 演示模式直接返回默认用户信息
    GetUserInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        // 演示模式：直接设置默认用户信息，不请求后端
        const defaultPermissions = new Set(['all'])
        const defaultButtons = ['all']
        
        commit('SET_PERMISSIONS', defaultPermissions)
        commit('SET_BUTTONS', defaultButtons)
        commit('SET_AVATAR', '')
        commit('SET_USERID', '1')
        commit('SET_NAME', 'GIMC-Admin')
        commit('SET_THIRD_ACCOUNT', [])
        
        resolve({
          data: {
            user: {
              id: '1',
              name: 'GIMC-Admin',
              avatar: ''
            },
            privilegeList: []
          }
        })
      })
    },
    // 第三方验证登录
    // LoginByThirdparty({ commit, state }, code) {
    //   return new Promise((resolve, reject) => {
    //     commit('SET_CODE', code)
    //     loginByThirdparty(state.status, state.email, state.code).then(response => {
    //       commit('SET_TOKEN', response.data.token)
    //       setToken(response.data.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 登出
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_BUTTONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        try {
          // 清除所有状态
          commit('SET_TOKEN', '')
          commit('SET_PERMISSIONS', new Set())
          commit('SET_BUTTONS', [])
          commit('SET_ROLES', [])
          commit('SET_NAME', '')
          commit('SET_AVATAR', '')
          commit('SET_USERID', '')
          commit('SET_THIRD_ACCOUNT', [])
          commit('SET_WXMODEL', false)
          commit('SET_WX_HASBIND', false)
          
          // 清除本地存储
          removeToken()
          
          // 清除路由缓存
          if (router && router.app && router.app.$store) {
            router.app.$store.commit('permission/SET_ROUTERS', [])
          }
          
          console.log('用户已登出，状态已清理')
          resolve()
        } catch (error) {
          console.error('登出过程中发生错误:', error)
          // 即使出错也要确保基本清理完成
          commit('SET_TOKEN', '')
          removeToken()
          resolve()
        }
      })
    },

    // 动态修改权限
    ChangeRoles ({ commit, dispatch }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getUserInfo(role).then(response => {
          const data = response.data
          commit('SET_ROLES', data.roles)
          commit('SET_NAME', data.name)
          dispatch('GenerateRoutes', data) // 动态修改权限后 重绘侧边菜单
          resolve()
        })
      })
    },
    
    // 获取权限
    getPermissions ({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(response => {
          let data
          if (response.data && response.data.data) {
            data = response.data.data
          } else if (response.data) {
            data = response.data
          } else {
            reject(new Error('error'))
            return
          }
          
          if (data.privilegeList) {
            let permissions = setPermissions(data.privilegeList)
            if (permissions && permissions.size > 0) {
              commit('SET_PERMISSIONS', permissions)
              resolve(permissions)
            } else {
              reject(new Error('权限列表为空'))
            }
          } else {
            reject(new Error('权限列表加载失败'))
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

/**
 * 根据权限渲染permission列表
 * @param permissions  permission列表
 */
function setPermissions (permissions) {
  if (permissions && permissions instanceof Array && permissions.length > 0) {
    let res = permissions.map(val => {
      return val.accessValue
    })
    const permissionSet = new Set(res)
    return permissionSet
  }
  return new Set()
}
export default user
